import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setAgendaState, getAgendaPDF, setDocumentLoading } from '../actions';
import DialIn from './dial-in';
import DownloadDocument from './download-document';

class Agenda extends Component {

	constructor( props ) {
		super( props );
		this.state = { show_info: [] };
	}

	isEmpty( obj ) {
		return !obj || Object.keys( obj ).length === 0;
	}

	checkAgendaExists() {
		return (this.props.agenda !== '' || this.props.agenda_document.length > 0);
	}

	changeDropDownState( type ) {
		let currentState = this.state.show_info;
		let meeting_id = this.props.meet_id;
		if ( typeof currentState[ meeting_id ] !== 'undefined' ) {
			if ( currentState[ meeting_id ] === type ) {
				currentState.splice( meeting_id, 1 );
			} else {
				currentState[ meeting_id ] = type;
			}
		} else {
			currentState[ meeting_id ] = type;
		}
		this.setState( { currentState } );
	}

	getDropDownText( meeting_id, drop_down_type ) {
		var mainText = '';
		var is_available = true;
		switch ( drop_down_type ) {
			case 'dial-in':
				mainText = 'Dial-In Details';
				is_available = (!this.isEmpty( this.props.info )
				);
				break;
			case 'online-meeting-information':
				mainText = 'Online Meeting Details';
				is_available = (this.props.online_meeting_information !== ''
				);
				break;
			case 'agenda':
				mainText = 'Agenda';
				is_available = this.checkAgendaExists();
				break;
		}
		if ( !is_available ) {
			text = 'No ' + mainText + ' Available';
			return (
				<div className={ 'meeting-information-section no-meeting-information' }>{ text }</div>
			);
		}
		var text = 'Show ' + mainText;
		var chevronClass = 'glyphicon-chevron-down';
		if ( typeof this.state.show_info[ meeting_id ] !== 'undefined' ) {
			if ( this.state.show_info[ meeting_id ] === drop_down_type ) {
				text = 'Hide ' + mainText;
				chevronClass = 'glyphicon-chevron-up';
			}
		}

		return (
			<div className="meeting-information-section">
				<button className={ 'view-details text-button' } onClick={ this.changeDropDownState.bind( this, drop_down_type ) } data-meeting-id={ this.props.meet_id } data-ccode={ this.props.ccode } type="button">{ text }<span aria-hidden="true" className={ 'glyphicon  ' + chevronClass + ' display-meeting-icon dial-in-dropdown' } data-meeting-id={ this.props.meet_id } data-ccode={ this.props.ccode } />
				</button>
			</div>
		);
	}

	getMeetingInfoDropDowns() {
		var content = this.getMeetingInfoContent( this.props.meet_id );
		var dial_in = (this.props.type === 'upcoming' || this.props.type === 'ongoing'
		              )
			? this.getDropDownText( this.props.meet_id, 'dial-in' )
			: '';
		var online_meeting_information = (this.props.type === 'upcoming' || this.props.type === 'ongoing'
		                                 )
			? this.getDropDownText( this.props.meet_id, 'online-meeting-information' )
			: '';
		return (<div>
			<div className="show-agenda-dropdown">
				{ this.getDropDownText( this.props.meet_id, 'agenda' ) }
				{ dial_in }
				{ online_meeting_information }
			</div>
			{ content }
		</div>
		);
	}

	getMeetingInfoContent( meeting_id ) {
		if ( typeof this.state.show_info[ meeting_id ] !== 'undefined' ) {
			var type = this.state.show_info[ meeting_id ];
			switch ( type ) {
				case 'agenda':
					return this.getAgendaContent();
					break;
				case 'dial-in':
					return (
						<DialIn meet_id={ this.props.meet_id } info={ this.props.info } type={ this.props.type } ccode={ this.props.ccode } />
					);
					break;
				case 'online-meeting-information':
					return (
						<div className={ 'meeting-content active' }>
							<div dangerouslySetInnerHTML={ { __html: this.props.online_meeting_information } }></div>
						</div>
					);
					break;
				default:
					return '';
			}
		} else {
			return '';
		}
	}

	downloadAgenda() {
		if ( this.props.agenda !== '' ) {
			return (
				<div className="download-agenda" data-ccode={ this.props.ccode } data-meet-id={ this.props.meet_id } onClick={ this.getAgenda.bind( this, this.props.meet_id ) }>
					<i className="glyphicon glyphicon-download"></i> Download Agenda
				</div>
			);
		} else {
			return '';
		}
	}

	showPopUpError() {
		return (
			<div className="bg-warning popup-message">Please enable pop ups for this site to download the agenda.</div>
		);

	}

	getAgenda( meet_id ) {
		this.props.setDocumentLoading( meet_id );
		this.props.getAgendaPDF( meet_id );
	}

	getAgendaContent() {
		if ( this.checkAgendaExists() ) {
			let downloadAgenda = this.downloadAgenda();
			let agendaDocument = '';
			if ( this.props.agenda_document.length > 0 ) {
				let agenda = this.props.agenda_document[ 0 ];
				agendaDocument = (
					<DownloadDocument file_name={ agenda.file_name } download_file_name={ agenda.download_file_name } ccode={ this.props.ccode } id={ agenda.ID } meet_id={ this.props.meet_id } bucket_name={agenda.bucket_name} />
				);
			}
			return (
				<div className={ 'meeting-content active' }>
					<div dangerouslySetInnerHTML={ { __html: this.htmlToText( this.props.agenda ) } }>
					</div>
					{ downloadAgenda }
					{ agendaDocument }
				</div>
			);

		}
	}

	htmlToText( html ) {
		let element = document.createElement( 'div' );
		element.innerHTML = html;
		return element.textContent;
	}

	render() {
		const meetingDropDowns = this.getMeetingInfoDropDowns();
		let popUpMessage = '';

		if ( this.props.meet_id === this.props.popUpMeetingID ) {
			popUpMessage = this.showPopUpError();
		}
		return (
			<div className="agenda-container">
				{ meetingDropDowns }
				{ popUpMessage }
			</div>

		);
	}

}

function mapStateToProps( { documents, agendaStatus, documentLoading, popUpMeetingID } ) {
	return { documents, agendaStatus, documentLoading, popUpMeetingID };
}

export default connect( mapStateToProps, {
	getAgendaPDF,
	setDocumentLoading
} )( Agenda );

